<template>
    <Header ueberschrift="Fahrzeugverwaltung" />
    <div>
      <div v-if="fahrzeugActive" id="fahrzeugverwaltung">
        <span v-for="fahrzeug in this.fahrzeuge" :key="fahrzeug.fahrzeugId">
          <Fahrzeug :fahrzeug="fahrzeug" @updateFahrzeugTable="this.refreshFahrzeuge()" @fahrzeugBearbeiten="this.fahrzeugBearbeiten(fahrzeug)"/>
        </span>
        <button class="plus-button" @click="this.neuesFahrzeugFormular()">+</button>
      </div>
      <div v-if="fahrzeugBearbeitenActive">
        <FahrzeugBearbeiten :fahrzeug="this.activeFahrzeug" @openFahrzeugFach="openFahrzeugFach"/>
      </div>
      <div v-if="fahrzeugFachActive">
        <FahrzeugFach :fahrzeug="this.activeFahrzeug" :fach="this.activeFach"/>
      </div>
    </div>
    <div v-show="this.fahrzeugBearbeitenActive" id="FahrzeugFooter">
        <a id="FahrzeugHomeButton" @click="openFahrzeugHome()">
          <img src="@/assets/Icons/HomeButton.svg">
        </a>
    </div>
    <div v-show="this.fahrzeugFachActive" id="FahrzeugFooter">
        <a id="FahrzeugHomeButton" @click="fahrzeugBearbeiten(this.activeFahrzeug)">
          <img src="@/assets/Icons/HomeButton.svg">
        </a>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Fahrzeug from "@/components/Fahrzeug.vue";
import FahrzeugBearbeiten from "@/components/FahrzeugBearbeiten.vue";
import FahrzeugFach from "@/components/FahrzeugFach.vue";
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: "FahrzeugVerwaltung",
  components: {
    Header,
    Footer,
    Fahrzeug,
    FahrzeugBearbeiten,
    FahrzeugFach
  },
  props: {
    
  },
  data() {
    return {
      fahrzeuge: [],
      fahrzeugActive: true,
      fahrzeugBearbeitenActive: false,
      fahrzeugFachActive: false,
      activeFahrzeug: {},
      activeFach: {},
    };
  },
  methods: {

    async getFahrzeuge() {
      var konvKey = this.$route.params.id.replace(":", "");
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/fahrzeug',
          { params: { konvKey: konvKey } }
        );
        console.log(response.data);
        return response.data;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async neuesFahrzeugFormular() {
      console.log("Test");
    var html = "";
    html += `<input style="width: 100%" id="name" maxLength="20" class="swal2-input" placeholder="Bezeichnung" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;
    html += `<input style="width: 100%" type="number" id="AnzahlFaecher" class="swal2-input" placeholder="Anzahl Fächer" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;
    html += `<input type="file" id="file" class="swal2-input" placeholder="Bild hochladen">`;

    const { value: formValues } = await Swal.fire({
        title: "Fahrzeug anlegen",
        html: html,
        focusConfirm: false,
        preConfirm: () => {
            const file = document.getElementById("file").files[0];
            const name = document.getElementById("name").value;
            const AnzahlFaecher = document.getElementById("AnzahlFaecher").value;
            return { name, file, AnzahlFaecher };
        }
    });

    if (formValues) {
        const file = formValues.file;
        const name = formValues.name;
        const AnzahlFaecher = formValues.AnzahlFaecher;

        // FormData erstellen, um Bild zu senden
        const formData = new FormData();
        formData.append('file', file);

        // Upload der Datei ans Backend
        try {
            const response = await fetch('https://feuerwehr-server.org:5000/upload-image-endpoint', {
                method: 'POST',
                body: formData
            });

            const result = await response.json(); // der Pfad oder das Ergebnis vom Backend
            if (result.success) {
                // Wenn der Upload erfolgreich war, Fahrzeug anlegen
                const imagePath = result.filePath; // Bildpfad vom Backend
                this.createFahrzeug(name, imagePath, AnzahlFaecher); // Fahrzeug mit Bildpfad erstellen
            }
        } catch (error) {
            console.error('Error uploading the file:', error);
        }
    }
},
        async getFeuerwehr(){
        try{
          var konvKey = this.$route.params.id.replace(":", "");
          const response = await axios.get(
              'https://feuerwehr-server.org:5000/feuerwehrBykonvKey',{ params: { konvKey: konvKey } }
          );
          return response.data.feuerwehrID;
        } catch (err){
          console.log(err);
        }
    },
    async getMaxFahrzeugID(feuerwehrID) {
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/maxFahrzeugID',
          { params: { feuerwehrID: feuerwehrID } }
        );
        console.log(response.data);
        return response.data.maxFahrzeugID;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async createFahrzeug(bezeichnung, imagePath, AnzahlFaecher){
      var feuerwehrID = await this.getFeuerwehr();
      var fahrzeugID = await this.getMaxFahrzeugID(feuerwehrID) + 1;
      console.log(fahrzeugID);
      const fahrzeugData = {
        name: bezeichnung,
        feuerwehrID: feuerwehrID,
        fahrzeugID: fahrzeugID,
        imagePath: imagePath,
      };

      axios.post('https://feuerwehr-server.org:5000/addFahrzeug', fahrzeugData)
        .then(response => {
            console.log('Erfolgreich registriertes Fahrzeug:', response.data);
            // Hier könntest du entsprechende Aktionen ausführen, z.B. Benutzer weiterleiten, eine Erfolgsmeldung anzeigen, etc.
            this.createFaecher(fahrzeugID, AnzahlFaecher);
            this.refreshFahrzeuge();
        })
        .catch(error => {
            console.error('Fehler bei der Fahrzeugregistrierung:', error.response.data);
            Swal.fire("Es ist ein Fehler aufgetreten", "Bitte wenden Sie sich an den Administrator", "error");
            // Hier könntest du Fehlerhandhabung durchführen, z.B. eine Fehlermeldung anzeigen, den Benutzer dazu auffordern, es erneut zu versuchen, etc.
        });
    },
    async refreshFahrzeuge(){
      this.fahrzeuge = [];
      this.fahrzeuge = await this.getFahrzeuge();
    },
    async createFaecher(fahrzeugID, AnzahlFaecher){
      AnzahlFaecher = +AnzahlFaecher - 1;
      this.createFach(fahrzeugID.toString(), '1', 'Fa');
      this.createFach(fahrzeugID.toString(), '2', 'Ma');
      var count = 1;
      while(count <= AnzahlFaecher){
        this.createFach(fahrzeugID.toString(), (+count + +2).toString(), 'G'+count.toString());
        count++;
      }
      this.createFach(fahrzeugID.toString(), '98', 'Heck');
      this.createFach(fahrzeugID.toString(), '99', 'Dach');
    },
    async createFach(fahrzeugID, fachID, name){
      const fachData = {
        fachID: fachID,
        fahrzeugID: fahrzeugID,
        name: name
      };

      axios.post('https://feuerwehr-server.org:5000/addFach', fachData)
        .then(response => {
            console.log('Erfolgreich registriertes Fach:', response.data);
            // Hier könntest du entsprechende Aktionen ausführen, z.B. Benutzer weiterleiten, eine Erfolgsmeldung anzeigen, etc.
        })
        .catch(error => {
            console.error('Fehler bei der Fachregistrierung:', error.response.data);
            Swal.fire("Es ist ein Fehler aufgetreten", "Bitte wenden Sie sich an den Administrator", "error");
            // Hier könntest du Fehlerhandhabung durchführen, z.B. eine Fehlermeldung anzeigen, den Benutzer dazu auffordern, es erneut zu versuchen, etc.
        });
    },
    async getMaxFachID(fahrzeugID) {
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/maxFachID',
          { params: { fahrzeugID: fahrzeugID } }
        );
        console.log(response.data);
        return response.data.maxFachID;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    fahrzeugBearbeiten(fahrzeug){
      this.activeFahrzeug = fahrzeug;
      this.fahrzeugActive = false;
      this.fahrzeugBearbeitenActive = true;
      this.fahrzeugFachActive = false;
    },
    openFahrzeugHome(){
      this.fahrzeugActive = true;
      this.fahrzeugBearbeitenActive = false;
      this.fahrzeugFachActive = false;
    },
    openFahrzeugFach(fahrzeug){
      console.log("openFahrzeugFach");
      this.activeFahrzeug = fahrzeug.fahrzeugObj;
      this.activeFach = fahrzeug.fachObj;
      this.fahrzeugActive = false;
      this.fahrzeugBearbeitenActive = false;
      this.fahrzeugFachActive = true;
    }
  },
  async created(){
    //console.log(this.benutzer.data);
    this.fahrzeuge = await this.getFahrzeuge();
  },
  setup() {
    const emits = ['updateFahrzeugTable', 'fahrzeugBearbeiten', 'openFahrzeugFach'];
    return { emits };
  }
};
</script>

<style lang="scss">
#fahrzeugverwaltung{
    margin-top: 5.5rem;
    //max-height: 500px;
    height: 82vh;
    overflow-y: auto;

    button{
      margin-top: 0.4rem;
      padding: 0.2rem !important;
      width: 3.8rem !important;
      height: 3.8rem !important;
      line-height:0;
    }

    .plus-button{
      font-size: 3.6rem;
      color: white;
      background-color: blue;
      border-radius: 0.5rem;
      font-weight: bold;
    }
}

#FahrzeugFooter{
      background-color: #C00000;
      position: fixed;
      margin: 0;
      padding: 0;
      bottom: 0;
      height: 4.5rem;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      z-index: 10000;
    }

    #FahrzeugHomeButton{
        cursor: pointer;
        img{
            height: 3.6rem;
            background-color: none;
            cursor: pointer;
        }
    }

@media screen and (max-height: 768px) {
  #fahrzeugverwaltung{
    margin-bottom: 10vh;
  }
}
</style>